var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var ReviewServiceSvg = /* @__PURE__ */ __name(function ReviewServiceSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 129.7 72"
  }, /* @__PURE__ */ React.createElement("g", {
    id: "Layer_1"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M33.2,60.2c0-0.6-0.2-1.1-0.7-1.5c-0.4-0.4-1.2-0.7-2.3-1c-1.4-0.3-2.4-0.8-3.2-1.4c-0.8-0.6-1.1-1.4-1.1-2.4 c0-1,0.4-1.8,1.2-2.5c0.8-0.7,1.9-1,3.2-1c1.4,0,2.5,0.4,3.3,1.2c0.8,0.8,1.2,1.7,1.2,2.7l0,0.1h-1.7c0-0.8-0.2-1.4-0.7-1.8 c-0.5-0.5-1.2-0.7-2.1-0.7c-0.9,0-1.5,0.2-2,0.6c-0.5,0.4-0.7,0.9-0.7,1.5c0,0.6,0.2,1,0.7,1.4c0.5,0.4,1.3,0.7,2.4,1 c1.3,0.3,2.4,0.8,3.1,1.5c0.7,0.6,1.1,1.5,1.1,2.4c0,1-0.4,1.9-1.3,2.5c-0.8,0.6-1.9,0.9-3.3,0.9c-1.3,0-2.4-0.3-3.4-1 c-1-0.7-1.5-1.6-1.4-2.8l0-0.1h1.7c0,0.8,0.3,1.4,0.9,1.9c0.6,0.4,1.3,0.6,2.2,0.6c0.9,0,1.6-0.2,2.1-0.6 C33,61.3,33.2,60.8,33.2,60.2z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M46.4,57.5h-5.9v4.6h6.8v1.4h-8.5V50.6h8.4V52h-6.7v4.1h5.9V57.5z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M52.4,57.9v5.5h-1.7V50.6h4.6c1.4,0,2.5,0.3,3.2,0.9c0.7,0.6,1.1,1.5,1.1,2.7c0,0.7-0.2,1.2-0.5,1.7s-0.8,0.9-1.5,1.2 c0.7,0.2,1.2,0.6,1.5,1.1s0.5,1.1,0.5,1.9v1.2c0,0.4,0,0.8,0.1,1.1c0.1,0.3,0.2,0.6,0.5,0.8v0.2h-1.8c-0.2-0.2-0.4-0.5-0.4-0.9 c-0.1-0.4-0.1-0.8-0.1-1.2v-1.2c0-0.7-0.2-1.2-0.6-1.7c-0.4-0.4-0.9-0.6-1.6-0.6H52.4z M52.4,56.5h2.7c1,0,1.7-0.2,2.1-0.6 s0.6-0.9,0.6-1.7c0-0.7-0.2-1.3-0.6-1.7s-1.1-0.6-2-0.6h-2.9V56.5z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M67.6,60.2l0.3,1h0.1l0.3-1l3.3-9.6h1.9l-4.8,12.8h-1.5l-4.8-12.8h1.9L67.6,60.2z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M78.3,63.4h-1.7V50.6h1.7V63.4z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M92,59.3L92,59.3c0,1.3-0.4,2.3-1.2,3.1c-0.9,0.8-2,1.2-3.4,1.2c-1.4,0-2.6-0.5-3.5-1.5c-0.9-1-1.4-2.3-1.4-3.9v-2.3 c0-1.6,0.5-2.9,1.4-3.9c0.9-1,2.1-1.5,3.5-1.5s2.6,0.4,3.5,1.2c0.9,0.8,1.3,1.8,1.2,3.1l0,0.1h-1.7c0-0.9-0.3-1.6-0.8-2.1 c-0.5-0.5-1.3-0.8-2.2-0.8c-1,0-1.7,0.4-2.3,1.2c-0.6,0.8-0.9,1.7-0.9,2.9v2.3c0,1.2,0.3,2.1,0.9,2.9c0.6,0.8,1.3,1.2,2.3,1.2 c1,0,1.7-0.3,2.2-0.8c0.5-0.5,0.8-1.2,0.8-2.1H92z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M103.3,57.5h-5.9v4.6h6.8v1.4h-8.5V50.6h8.4V52h-6.7v4.1h5.9V57.5z"
  })), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M12.3,29.5l7.5,4.5l-2-8.5l6.6-5.7L15.7,19l-3.4-8l-3.4,8l-8.7,0.7l6.6,5.7l-2,8.5L12.3,29.5z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M38.6,29.5l7.5,4.5l-2-8.5l6.6-5.7L42,19l-3.4-8l-3.4,8l-8.7,0.7l6.6,5.7l-2,8.5L38.6,29.5z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M64.9,29.5l7.5,4.5l-2-8.5l6.6-5.7L68.3,19l-3.4-8l-3.4,8l-8.7,0.7l6.6,5.7l-2,8.5L64.9,29.5z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M91.2,29.5l7.5,4.5l-2-8.5l6.6-5.7L94.5,19l-3.4-8l-3.4,8l-8.7,0.7l6.6,5.7l-2,8.5L91.2,29.5z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M117.4,29.5l7.5,4.5l-2-8.5l6.6-5.7l-8.7-0.7l-3.4-8l-3.4,8l-8.7,0.7l6.6,5.7l-2,8.5L117.4,29.5z"
  }))), /* @__PURE__ */ React.createElement("g", {
    id: "Layer_2"
  }));
}, "ReviewServiceSvg");
var ReviewServiceIcon = /* @__PURE__ */ __name(function ReviewServiceIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: ReviewServiceSvg
  }, props));
}, "ReviewServiceIcon");
export {
  ReviewServiceIcon
};
